import { Breadcrumbs, PageLayout } from 'components'
import { Col, Row } from 'antd'

import { TicketAdvancedForm } from 'domains/Ticket/components'
import { useNavigate } from 'react-router-dom'
import { useTranslations } from 'hooks'

const TicketCreatePage = (props) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting navigate instance */
  const navigate = useNavigate()

  /* Configuring page header */
  const headingProps = {
    title: t('Ticket create'),
    textAlign: 'left'
  }

  /* Function to handle back click */
  const handleBack = () => navigate(-1)

  return (
    <PageLayout
      onBack={handleBack}
      breadcrumbs={<Breadcrumbs />}
      headingProps={headingProps}
      area="ticket">
      <Row>
        <Col xs={24} md={20} lg={16} xl={14}>
          <TicketAdvancedForm />
        </Col>
      </Row>
    </PageLayout>
  )
}

export default TicketCreatePage
